<list-view *ngIf="baliseService.listeBaliseView" [liste]="baliseService.listeBaliseView" [hover]="false"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>